import {
    Box,
    Typography,
    Container,
    Button,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Animator from "../../components/Aminator/Animator";
import { useNavigate } from "react-router-dom";
import image from "../../assets/images/consultancy.jpg"
import { useIsMobile } from "../../components/hooks/useIsMobile";
export default function HeroSection() {

// Styled components (unchanged)
    const HeroSection = styled(Box)(({ theme }) => ({
        position: "relative",
        backgroundColor: "#0A0E1A",
        color: "#fff",
        overflow: "hidden",
        minHeight: `${isMobile ? "100vh" : "100vh"}`,
        marginTop: `${isMobile ? "70px" : "132px"}`,
        display: "flex",
        alignItems: "center",
        padding: { xs: theme.spacing(4, 2), md: theme.spacing(4, 5) },
        backgroundImage: `url(${image})`,
        backgroundSize: "cover",
        backgroundPosition: "right center",
        backgroundRepeat: "no-repeat",

        "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1,
            background: "linear-gradient(89.85deg, #000000 0.13%, #000000 0.14%, rgba(0, 0, 0, 0) 99.56%)"
        },
    }));

const ContentContainer = styled(Container)(({ theme }) => ({
    position: "relative",
    zIndex: 2,
    display: "flex",
    flexDirection: "column",

    [theme.breakpoints.up("md")]: {
        flexDirection: "row",
        alignItems: "center",
    },
}));

const TextContent = styled(Box)(({ theme }) => ({
    // paddingLeft: theme.spacing(4),
    [theme.breakpoints.up("md")]: {
        width: "70%",
        paddingRight: theme.spacing(4),
        paddingLeft: theme.spacing(8),
    },
    [theme.breakpoints.down("xs")]: {
        width: "100%",
        paddingRight: theme.spacing(0),
    },
}));
 
const DarkButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#F05A19",
  color: "#fff",
  padding: theme.spacing(1.5, 4),
  borderRadius: "4px",
  textTransform: "none",
  fontWeight: 600,
  "&:hover": {
    backgroundColor: "#222222",
  },
}))

const OutlinedButton = styled(Button)(({ theme }) => ({
  borderColor: "#Fff",
  color: "#Fff",
  padding: theme.spacing(1.5, 4),
  borderRadius: "4px",
  textTransform: "none",
  fontWeight: 600,
  marginLeft: theme.spacing(2),
  "&:hover": {
    borderColor: "#E64A19",
    backgroundColor: "rgb(14, 0, 12)",
  },
  [theme.breakpoints.down("sm")]: {
    marginLeft: 0,
    marginTop: theme.spacing(2),
  },
}))


  const isMobile = useIsMobile();
    const navigate = useNavigate();

  return (
    <HeroSection>
      <ContentContainer maxWidth="false">
        <TextContent>
          
          <Animator variant="slide" direction="right" timeout={800} delay={300} >
            <Typography
              variant="h2"
              component="h1"
              sx={{
                fontWeight: 700,
                fontSize: { xs: "40px", md: "56px" },
                lineHeight: 1.2,
                
                fontFamily: "'Montserrat', sans-serif",
                mb: "20px",
              }}
            >
              Give Your Team The Skill To Deliver More Faster 
              
            </Typography>
          </Animator>

          <Animator variant="fade" timeout={800} delay={400}>
            <Typography
              variant="body1"
              sx={{
                
                fontSize: { xs: "16px", md: "18px" },
                fontWeight: 500,
                lineHeight: 1.6,
                maxWidth: "90%",
                fontFamily: "'Montserrat', sans-serif",
                mb: "49px",
              }}
            >
             Transform your existing workforce into a high-performing powerhouse without incurring the costs of hiring.
            </Typography>
          </Animator>  
          <Animator variant="fade" timeout={800} delay={500}>
            <Box
              sx={{
                display: "flex",
                gap: 2,
                flexDirection: { xs: "column", sm: "row" },
              }}
            >
                <DarkButton variant="contained" disableElevation onClick={() => {
                    navigate("/");
                }}>
                Book a Consultation
              </DarkButton>
                <OutlinedButton variant="outlined" onClick={() => {
                    navigate("/courses/categories");
                }}> Request a Quote</OutlinedButton>
               
            </Box>
          </Animator>        
        </TextContent>
      </ContentContainer>
    </HeroSection>
  );
}

